import { defineMessages } from '@atlassian/jira-intl';

export const commonMessages = defineMessages({
	dismiss: {
		id: 'eoc-on-call.common.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Action button that dismiss spotlight',
	},
	learnMore: {
		id: 'eoc-on-call.common.learn-more',
		defaultMessage: 'Learn More',
		description: 'Action button that redirects user to learn more page',
	},
	next: {
		id: 'eoc-on-call.common.next',
		defaultMessage: 'Next',
		description: 'Action button that goes next spotlight',
	},
	ok: {
		id: 'eoc-on-call.common.ok',
		defaultMessage: 'OK',
		description: 'Action button that finishes spotlight',
	},
	back: {
		id: 'eoc-on-call.common.back',
		defaultMessage: 'Back',
		description: 'Action button that goes previous spotlight',
	},
});
